import { itx } from "../../../src/translationItx/itx";
import Handlebars from "handlebars";
import COVER_MARKDOWN from "../data/markdown/cover.md?raw";
import CHAPTER_COVER_MARKDOWN from "../data/markdown/chapter-cover.md?raw";
import C1_DOCUMENTATION_MARKDOWN from "../data/markdown/Page1.md?raw";
import { C1_MarkdownPdfRenderer, type C1_MarkdownPdfPrimitives } from "./C1_MarkdownPdfRenderer";

export { COVER_MARKDOWN as C1_COVER_MARKDOWN, CHAPTER_COVER_MARKDOWN as C1_CHAPTER_COVER_MARKDOWN };

export function getC1DocumentationMarkdown(): string {
  return itx("c1.report.introductionMarkdown", C1_DOCUMENTATION_MARKDOWN);
}

export type C1_RaumbuchCoverPdfPrimitives = C1_MarkdownPdfPrimitives;

export function C1_RaumbuchCoverMarkdown({
  primitives,
  documentName = itx("pageDocumentType.roombook", "Raumbuch"),
  markdownTemplate = COVER_MARKDOWN,
  textAlign = "center",
  projectName,
  dateText,
  logo,
  substitutionValues,
}: {
  primitives: C1_RaumbuchCoverPdfPrimitives;
  documentName?: string;
  markdownTemplate?: string;
  textAlign?: "center" | "left";
  projectName: string;
  dateText: string;
  logo: string;
  substitutionValues?: Record<string, string>;
}) {
  const { View } = primitives;
  const markdown = Handlebars.compile(markdownTemplate)({
    DocName: documentName,
    ProjectName: projectName,
    UserName: "ESTADA",
    Date: dateText,
    BrandName: "ESTADA",
    ProductName: "Concept One",
    ChapterNumber: "",
    ChapterTitle: documentName,
    ProjectLabel: itx("cover.project", "Projekt"),
    AuthorLabel: itx("cover.creator", "Ersteller"),
    ChapterLabel: itx("c1.report.chapter", "Kapitel"),
    ...substitutionValues,
  });
  const content = (
    <C1_MarkdownPdfRenderer markdown={markdown} primitives={primitives} logo={logo} textAlign={textAlign} />
  );

  return textAlign === "left" ? (
    <View style={{ width: "15cm", alignSelf: "center", flexDirection: "column" }}>{content}</View>
  ) : (
    content
  );
}

export async function createC1MarkdownCoverPdfBlob({
  documentName,
  markdownTemplate,
  textAlign = "center",
  projectName,
  dateText,
  logo,
  substitutionValues,
  pageSize = "A4",
  orientation = "portrait",
}: {
  documentName: string;
  markdownTemplate?: string;
  textAlign?: "center" | "left";
  projectName: string;
  dateText: string;
  logo: string;
  substitutionValues?: Record<string, string>;
  pageSize?: "A3" | "A4";
  orientation?: "portrait" | "landscape";
}): Promise<Blob> {
  const { pdf, Document, Page, View, Text, Link, Image } = await import("@react-pdf/renderer");
  const document = (
    <Document title={`${documentName} · ${projectName}`} author="ESTADA">
      <Page
        size={pageSize}
        orientation={orientation}
        style={{
          padding: 28.35,
          fontFamily: "Helvetica",
          fontSize: 10,
          color: "#172b3a",
          backgroundColor: "#fff",
        }}
      >
        <View style={{ height: "100%", width: "100%", position: "relative", alignItems: "center", justifyContent: "center" }}>
          <C1_RaumbuchCoverMarkdown
            primitives={{ View, Text, Link, Image }}
            documentName={documentName}
            markdownTemplate={markdownTemplate}
            textAlign={textAlign}
            projectName={projectName}
            dateText={dateText}
            logo={logo}
            substitutionValues={substitutionValues}
          />
        </View>
      </Page>
    </Document>
  );
  return pdf(document).toBlob();
}
